import type { BrowserOptions } from '@sentry/angular';
import { THIRD_PARTY_WEBVIEW_BRIDGE_IGNORE_ERRORS } from './webview-bridge-error-filters';

export const WEBSITE_SENTRY_DSN =
  'https://0042d59ff1a2cb8c6b070b2f673511ff@o4509015588864000.ingest.us.sentry.io/4511350731571200';

/**
 * Builds the website's Sentry browser options.
 *
 * `ignoreErrors` always keeps the third-party in-app browser bridge patterns
 * declared by the website, even when callers supply their own list. Everything
 * else is forwarded untouched so the caller keeps ownership of sampling, PII,
 * integrations, and transport settings.
 */
export function buildSentryOptions(
  overrides: Partial<BrowserOptions> = {},
): BrowserOptions {
  const { ignoreErrors: extraIgnoreErrors = [], ...rest } = overrides;

  return {
    dsn: WEBSITE_SENTRY_DSN,
    sendDefaultPii: true,
    ...rest,
    ignoreErrors: [
      ...THIRD_PARTY_WEBVIEW_BRIDGE_IGNORE_ERRORS,
      ...extraIgnoreErrors,
    ],
  };
}
